import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PortalConfigurationType, VendorProfile } from '@trnsact/trnsact-shared-types';
import { DEFAULT_LENDER_PAGE, DEFAULT_PARTNER_PAGE } from 'constants/common';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { useRoutesVisibilityChecks } from 'hooks/useRoutesVisibilityChecks';

export const FinanceProposalsRedirectPage = () => {
  const { isDealerUser, isLenderUser, isCommonPartner, isAftermarketPartner } = useContext(CommonDataContext);
  const userPortalType = useSelector((state: any) => state.userProfile?.portalType);
  const vendorProfile = useSelector((state: any) => state.vp) as VendorProfile;
  const opportunitiesConfiguration = useSelector(
    (state: any) => state.portalConfiguration?.[PortalConfigurationType.Opportunities]
  );
  const { checkIfProposalsHubVisible } = useRoutesVisibilityChecks();
  const isUserRoleReady = Boolean(userPortalType);
  const isDealerPortalConfigurationReady = !isDealerUser || Boolean(opportunitiesConfiguration);

  if (!isUserRoleReady || !isDealerPortalConfigurationReady) {
    return null;
  }

  const isProposalsVisible = checkIfProposalsHubVisible(
    isCommonPartner,
    isAftermarketPartner,
    isDealerUser,
    isLenderUser,
    vendorProfile
  );

  const fallbackRoute = isAftermarketPartner ? DEFAULT_PARTNER_PAGE : isLenderUser ? DEFAULT_LENDER_PAGE : '/finance';

  return <Redirect to={isProposalsVisible && isDealerUser ? '/finance#proposals' : fallbackRoute} />;
};
